import {AnyLinkType} from 'shared/pretty-easy-navigation/models';

export const GuestMenu: AnyLinkType[] = [
    {
        type: 'linkGroup',
        links: [
            {
                type: 'link',
                label: 'navigation.legal_notice',
                link: '/informations-legales',
                icon: 'navigation-link__legal-notice',
            },
            {
                type: 'link',
                label: 'navigation.contact',
                link: '/feedback',
                icon: 'navigation-link__contact',
            },
            {
                type: 'link',
                label: 'navigation.site_map',
                link: '/page/site-map',
                icon: 'navigation-link__sitemap',
            },
        ],
    },
];
